import { render, staticRenderFns } from "./BottomSlot.vue?vue&type=template&id=06dfadf3&scoped=true&lang=pug&"
import script from "./BottomSlot.ts?vue&type=script&lang=ts&"
export * from "./BottomSlot.ts?vue&type=script&lang=ts&"
import style0 from "./BottomSlot.vue?vue&type=style&index=0&id=06dfadf3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dfadf3",
  null
  
)

export default component.exports